const DefaultCalculator = require('./default.calculator');
const ShoppingCart = require('od-modules/cart/cart');

const getTotalPrice = (items = []) => items.reduce((total, {price = {}}) => total + price.total || 0, 0);

class AncillariesCalculator extends DefaultCalculator {
    get insurances() {
        return getTotalPrice(ShoppingCart.take.insurances());
    }

    get serviceOptions() {
        return getTotalPrice(ShoppingCart.take.serviceOptions());
    }

    get seats() {
        return getTotalPrice(ShoppingCart.take.seats());
    }

    get handBaggage() {
        return getTotalPrice(ShoppingCart.take.boardingOptions());
    }

    get baggage() {
        return getTotalPrice(ShoppingCart.take.bags());
    }

    get fareRules() {
        return getTotalPrice(ShoppingCart.take.fareRules());
    }

    get ancillaries() {
        return this.baggage + this.handBaggage + this.seats + this.insurances + this.serviceOptions + this.fareRules;
    }
}

module.exports = AncillariesCalculator;
